import { SendReleaseEmailRoles } from 'src/app/shared/models/autogenerated';
import { EntityCardOptionSelect } from 'src/app/shared/models/entity-card-option-select.model';

export const MANDATORY_CHECKS_TEMPLATES_ROUTE: string =
  'mandatory-checks-templates';
export const PEER_POOL_DISCIPLINES_ROUTE: string = 'peer-pool-disciplines';
export const DELIVERABLE_TEMPLATES_ROUTE: string = 'deliverable-templates';
export const BUSINESS_UNITS_ROUTE: string = 'business-units';
export const RISK_ASSESSMENT_ROUTE: string = 'risk-assessment';
export const ASSIGNMENTS_ROUTE: string = 'assignments';
export class GlobalSettingsRoutes {
  static readonly SME_ASSIGNMENTS = 'sme-assignments';
  static readonly DA_ASSIGNMENTS = 'da-assignments';
  static readonly PROJECT_CONTACT_ASSIGNMENTS = 'project-contact-assignments';
}

export enum SendReleaseEmailOptions {
  DA_ENGINEERS,
  CHAPTER_MANAGERS,
  SMES,
  PROJECT_CONTACTS,
  ALL_USERS,
}

export const SEND_RELEASE_EMAIL_OPTIONS_ARRAY: EntityCardOptionSelect[] =
  Object.values(SendReleaseEmailRoles).map((value) => ({
    text: value.replace(/-/g, ' ').toLowerCase(),
    value: value,
    onClick: () => {},
  }));
